import { CSSTransitionTime } from './config/global'

export default class Tabs {
	constructor(tabsElement) {
		this.tabsElement = tabsElement

		this.getDomElements()

		if (!this.dom.parent || !this.dom.wrapper) return
		
		this.tabs = []
		this.animating = false

		this.init()
	}


	init() {
		this.setTabs()
		this.handleClick()
		this.handleResize()

		this.dom.parent.classList.add('is-loaded')
	}


	handleClick() {
		this.tabs.forEach(tabItem => {
			tabItem.key.addEventListener('click', () => {
				if (tabItem.active || this.animating) return

				this.animateTabs(tabItem)
			})

			tabItem.accordionTrigger.addEventListener('click', () => {
				if (tabItem.active || this.animating) return

				this.animateTabs(tabItem)
			})
		})
	}


	handleResize() {
		window.addEventListener('resize', () => {
			this.setTabHeights()
		})
	}


	animateTabs(newTab) {
		let oldTab = this.tabs.filter((tab) => tab.active)
		oldTab = oldTab[0]

		this.animating = true
		this.dom.parent.classList.add('is-animating')

		if (window.innerWidth < 1024) {
			this.animateMobileAccordions(newTab, oldTab)
		} else {
			this.animateDesktopTabs(newTab, oldTab)
		}
	}


	animateMobileAccordions(newTab, oldTab) {
		newTab.element.style.height = '0px'
		newTab.element.style.opacity = 1
		newTab.element.style.display = 'block'

		oldTab.element.style.height = `${oldTab.elementHeight}px`
		
		setTimeout(() => {
			oldTab.element.style.height = '0px'
		}, 0)
		
		setTimeout(() => {
			oldTab.key.classList.remove('is-active')
			oldTab.accordionTrigger.classList.remove('is-active')
			oldTab.active = false

			newTab.element.style.height = `${newTab.elementHeight}px`
			newTab.key.classList.add('is-active')
			newTab.accordionTrigger.classList.add('is-active')
		}, 100)

		setTimeout(() => {
			newTab.element.style.height = 'auto'
			newTab.element.classList.add('isActive')
			newTab.active = true

			oldTab.element.classList.remove('isActive')
			oldTab.element.style.display = 'none'
			oldTab.element.style.height = 'auto'
			
			this.animating = false
			this.dom.parent.classList.remove('is-animating')
		}, CSSTransitionTime + 100)
	}


	animateDesktopTabs(newTab, oldTab) {
		this.dom.wrapper.style.height =  `${this.dom.wrapper.offsetHeight}px`
		
		setTimeout(() => {
			this.dom.wrapper.style.height = `${newTab.elementHeight}px`

			oldTab.key.classList.remove('is-active')
			oldTab.element.classList.remove('is-active')
			oldTab.element.style.opacity = 0

			newTab.key.classList.add('is-active')
			newTab.element.style.top =  '5px'
			newTab.element.style.display = 'block'
			newTab.element.style.position = 'absolute'
			newTab.element.style.opacity = 0
		}, 100)

		setTimeout(() => {
			oldTab.active = false

			newTab.element.style.top = 0
			newTab.element.style.opacity = 1 
		},CSSTransitionTime + 110)

		setTimeout(() => {
			this.dom.wrapper.style.height = 'auto'

			oldTab.element.style.display = 'none'
			newTab.element.style.position = 'relative'
			newTab.element.classList.add('is-active')
			newTab.active = true

			this.animating = false
			this.dom.parent.classList.remove('is-animating')
		}, (CSSTransitionTime * 2) - 90)
	}


	setTabs() {
		const keys = this.dom.parent.querySelectorAll('[data-tabs-key]')
		const tabs = this.dom.parent.querySelectorAll('[data-tabs-tab]')
		const accordions = this.dom.parent.querySelectorAll('[data-tabs-accordion]')

		if (!keys.length || !tabs.length || !accordions.length) return

		keys.forEach((key, index) => {
			let tabElement = tabs[index]
			let accordionElement = accordions[index]
			
			if (tabElement && accordionElement) {
				if (index == 0) {
					key.classList.add('is-active')
					tabElement.classList.add('is-active')
					accordionElement.classList.add('is-active')
				}

				this.tabs.push({
					index : index,
					key : key,
					element : tabElement,
					accordionTrigger : accordionElement,
					active : index == 0 ? true : false,
					elementHeight: 0,
				})
			}
		})

		this.setTabHeights()
	}


	setTabHeights() {
		this.tabs.forEach(tabItem => {
			tabItem.element.style.display = 'block'
			tabItem.elementHeight = tabItem.element.offsetHeight
			tabItem.element.style.display = tabItem.active ? 'block' : 'none'
		})
	}


	getDomElements() {
		this.dom = {
			parent: this.tabsElement,
			wrapper: this.tabsElement.querySelector('[data-wrapper]'),
		}
	}
}